module.exports = __webpack_public_path__ + "static/media/bloomsbox.19161963.svg";